import Navbar from "../../components/Navbar/Navbar";
import LinhaDado from "../../components/LinhaDado";
import EditInstituicao from "../../components/ModalForms/EditSituacaoInstituicao";
import { Instituicao } from "../../model/Instituicao";
import Cabecalho from "../../components/Cabecalho";
import MembrosData from "./data/MembrosData";
import getMembrosInstituicao from '../../services/getMembrosInstituicao'
import React, { useContext, useEffect, useState } from "react";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import styles from "./styles.module.css";
import { Membro } from "../../model/Membro";
import { useLocation, useParams } from "react-router-dom";
import { UserContext } from "../../context/UserContext";
import getInstituicao from "../../services/getInstituicao";

const selecionaCor = (situacao: string) => {
  switch (situacao) {
    case "aprovada":
      return styles.aprovado;
    case "pendente":
      return styles.pendente;
    case "reprovada":
      return styles.rejeitado;
  }
};

function ContextoInstituicao() {
  const location = useLocation();
  const { id } = useParams(); // ToDo: ajustar para quando abrirem link direto 
  const { token } = useContext(UserContext);
  const [openEditInst, setEditInst] = useState(false);
  const [instituicao, setInstituicao] = useState<Instituicao>(location.state);
  const [listaMembros, setListaMembros] = useState<Membro[]>(MembrosData);
    
  
  
  useEffect(() => {
    const listarMembrosERepresentante = async () => {
      try {
        /*if(instituicao === null)
          setInstituicao(await getInstituicao(token, id));*/
        const membros = await getMembrosInstituicao(token, instituicao.cnpj);
      
        const listaDeMembros: Membro[] = [];
        for (let i = 0; i < membros.length; i++) {
          listaDeMembros.push({ 
            nome: membros[i].user.name, 
            email: membros[i].user.email,
            cep: membros[i].cep,
            cidade: membros[i].cidade,
            estado: membros[i].estado,
            bairro: membros[i].bairro,
            rua: membros[i].rua,
            numero: membros[i].numero,
            complemento: membros[i].complemento,
            cpf: membros[i].user.cpf,
            rg: membros[i].rg,
            orgao: membros[i].orgao_expedidor,
            representante: membros[i].representante,
            data_inicio_mandato: membros[i].data_inicio_mandato,
            data_fim_mandato: membros[i].data_fim_mandato,
            cargo: membros[i].cargo,
          });
        }
        setListaMembros(listaDeMembros);
      } catch (error) {
        console.error("Erro ao buscar Membros da Instituição", error);
      }
    };
    listarMembrosERepresentante();
  }, []);
  
  return (
    <div className={styles.page}>
      <Navbar activeIndex={0} />
      <section>
        <Cabecalho title="Instituição" icon="group" />

        <main> 
          <div className={styles.container}>
              <h3>Dados da Instituição:</h3>
            <div className={styles.container_data}>
              <LinhaDado chave="Nome" valor={instituicao.nome} />
              <LinhaDado chave="CNPJ" valor={instituicao.cnpj} />
              <LinhaDado chave="Email" valor={instituicao.email} />
              <LinhaDado chave="Telefone" valor={instituicao.telefone} />
              <LinhaDado chave="Status" valor={instituicao.status} estilo={selecionaCor(instituicao.status)}/>
              {instituicao.observacao && <LinhaDado chave="Observação" valor={instituicao.observacao}/>}
              <hr />
              <h4 className={styles.subTitulo}>Endereço:</h4>
              <LinhaDado chave="CEP" valor={instituicao.cep} />
              <LinhaDado
                chave="Estado"
                valor={instituicao.estado}
              />
              <LinhaDado
                chave="Cidade"
                valor={instituicao.cidade}
              />
              <LinhaDado
                chave="Bairro"
                valor={instituicao.bairro}
              />
              <LinhaDado chave="Rua" valor={instituicao.rua} />
              <LinhaDado
                chave="Numero"
                valor={instituicao.numero}
              />
              {instituicao.complemento && (
                <LinhaDado
                  chave="Complemento"
                  valor={instituicao.complemento}
                />
              )}
              <hr />
              <button
                className={styles.editButton}
                onClick={() => setEditInst(true)}
              >
                Editar Situação
              </button>
            </div>

            <Modal
              open={openEditInst}
              onClose={() => setEditInst(false)}
              center
              classNames={{
                modal: styles.customModal,
              }}
            >
              <EditInstituicao
                instituicaoObj={instituicao}
                setInstituicao={setInstituicao}
                closeModal={() => setEditInst(false)}
              />
            </Modal>
          </div>

          {listaMembros.map((Membro, index) => (
            <div className={styles.container} key={index}>
              <h3>
                {Membro.representante
                  ? "Dados do Representante:"
                  : "Dados do Membro:"}
              </h3>
              <div className={styles.container_data}>
                <LinhaDado chave="Nome" valor={Membro.nome} />
                <LinhaDado chave="Email" valor={Membro.email} />
                <LinhaDado chave="Cargo" valor={Membro.cargo} />
                <LinhaDado chave="CPF" valor={Membro.cpf} />
                <LinhaDado chave="RG" valor={Membro.rg} />
                <LinhaDado chave="Órgão" valor={Membro.orgao} />

                <hr />
                <h4 className={styles.subTitulo}>Endereço:</h4>
                <LinhaDado chave="CEP" valor={Membro.cep} />
                <LinhaDado chave="Estado" valor={Membro.estado} />
                <LinhaDado chave="Cidade" valor={Membro.cidade} />
                <LinhaDado chave="Bairro" valor={Membro.bairro} />
                <LinhaDado chave="Rua" valor={Membro.rua} />
                <LinhaDado chave="Numero" valor={Membro.numero+""} />
                {Membro.complemento && (
                  <LinhaDado
                    chave="Complemento"
                    valor={Membro.complemento}
                  />
                )}
              </div>
            </div>
          ))}
          
        </main>
      </section>
    </div>
  );
}

export default ContextoInstituicao;